import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  Tab,
  Tabs,
} from "@material-ui/core";

import PropTypes from "prop-types";

import { TablaHistorial } from "./Menus/TablaHistorial";

import { getTrackingPresupuesto, getTrackingSolicitud } from "../../../actions/autorizaciones/Autorizaciones";

import { AUTORIZACIONES_MENU_HISTORIAL, TIPOS_AUTORIZACIONES } from "../../../utils/constants";
import { getTrackingSolicitudIntegracion } from "../../../actions/discapacidad/discapacidadActions";
import { AUTORIZACIONES_INTEGRACION_MENU_HISTORIAL, TIPO_SOLICITUD_INTEGRACION } from "../../Discapacidad/data/constants";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      name={index}
      {...other}
    >
      {value === index && <Box p={2}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

export const ModalHistorialCambios = (props) => {
  const dispatch = useDispatch();

  const { trackingSolicitud, trackingPresupuesto } = useSelector((state) => state.autorizaciones);
  const { trackingSolicitudIntegracion } = useSelector((state) => state.discapacidad);

  const [selectedTab, setSelectedTab] = useState(
    AUTORIZACIONES_MENU_HISTORIAL.SOLICITUD
  );

  const cambiosEnSolicitudes = [];
  const cambiosEnPresupuestos = [];
  const cambiosEnPracticas = [];
  const cambiosEnPeriodosPracticas = [];
  const cambiosEnMateriales = [];
  const cambiosEnTerapia = [];
  const cambiosEnTransporte = [];

  if(!props.openIntegracion){
    if(props.openPresupuesto){
      for (let i = 0; i < trackingPresupuesto.length; i++) {
        const item = trackingPresupuesto[i];
        if (!item?.idPractica && !item?.idMaterial) {
          cambiosEnPresupuestos.push(item);
        } else if (item?.idPractica && !item?.idMaterial) {
          cambiosEnPracticas.push(item);
        } else {
          cambiosEnMateriales.push(item);
        }
      }
    }else{
      for (let i = 0; i < trackingSolicitud.length; i++) {
        const item = trackingSolicitud[i];
        if (!item?.idPractica && !item?.idMaterial) {
          cambiosEnSolicitudes.push(item);
        } else if (item?.idPractica && (!item?.periodo || item?.periodo === '') && !item?.idMaterial) {
          cambiosEnPracticas.push(item);
        } else if (item?.idPractica && (item?.periodo && item?.periodo !== '') && !item?.idMaterial) {
          cambiosEnPeriodosPracticas.push(item);
        } else {
          cambiosEnMateriales.push(item);
        }
      }
    }
  }else{
    for (let i = 0; i < trackingSolicitudIntegracion.length; i++) {
      const item = trackingSolicitudIntegracion[i];      
      if (!item?.idPractica && !item?.datosTransporte && !item?.datosTerapia) {
        cambiosEnSolicitudes.push(item);
      } else if (item?.idPractica) {
        cambiosEnPracticas.push(item);
      } else if (item?.datosTransporte) {
        cambiosEnTransporte.push(item);
      } else {
        cambiosEnTerapia.push(item);
      }
    }
  }

  const { open } = props;

  useEffect(() => {
    setSelectedTab(AUTORIZACIONES_MENU_HISTORIAL.SOLICITUD);
  }, [open]);

  useEffect(() => {
    if(props.openIntegracion){
      dispatch(getTrackingSolicitudIntegracion(props.solicitud?.idSolicitud));
    }else{
      if(props.openPresupuesto){
        dispatch(getTrackingPresupuesto(props.presupuesto?.idPresupuesto));
      } else {
        dispatch(getTrackingSolicitud(props.solicitud?.idSolicitud));
      }
    }
  }, [props.openPresupuesto]);

  return (
    <Dialog
      fullWidth
      maxWidth={
        props.openPresupuesto 
        ? selectedTab === AUTORIZACIONES_MENU_HISTORIAL.PRESUPUESTO ? "md" : "lg"
        : selectedTab === AUTORIZACIONES_MENU_HISTORIAL.SOLICITUD ? "md" : "lg"
      }
      open={open}
      onClose={props.closeModalHandler}
    >
      <DialogTitle>Historial de Cambios - {props.titulo}</DialogTitle>
      <DialogContent>
        <Tabs
          value={selectedTab}
          onChange={(event, newValue) => setSelectedTab(newValue)}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
        >
          {props.openPresupuesto ?
            <Tab
              label="Presupuesto"
              {...a11yProps(AUTORIZACIONES_MENU_HISTORIAL.PRESUPUESTO)}
            />
            :
            <Tab
              label="Solicitud"
              {...a11yProps(AUTORIZACIONES_MENU_HISTORIAL.SOLICITUD)}
            />
          }
          <Tab
            label="Practicas"
            {...a11yProps(AUTORIZACIONES_MENU_HISTORIAL.PRACTICA)}
          />
          {!props.openIntegracion &&
            <Tab
              label="Materiales"
              {...a11yProps(AUTORIZACIONES_MENU_HISTORIAL.MATERIAL)}
            />
          }
          {(props.solicitud?.idTipoSolicitud ===
            TIPO_SOLICITUD_INTEGRACION.TERAPIA_INDIVIDUAL ||
            props.solicitud?.idTipoSolicitud ===
            TIPO_SOLICITUD_INTEGRACION.TERAPIA_MODULO) &&
            <Tab
              label="Terapia"
              {...a11yProps(AUTORIZACIONES_INTEGRACION_MENU_HISTORIAL.TERAPIA)}
            />
          }
          {props.solicitud?.idTipoSolicitud ===
            TIPO_SOLICITUD_INTEGRACION.TRANSPORTE &&
            <Tab
              label="Transporte"
              {...a11yProps(AUTORIZACIONES_INTEGRACION_MENU_HISTORIAL.TRANSPORTE)}
            />
          }
          {props.solicitud?.idTipoSolicitud === 
            TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION_DOMICILIARIA &&
            <Tab
              label="Periodos Practica"
              {...a11yProps(AUTORIZACIONES_MENU_HISTORIAL.PERIODO_PRACTICA)}
            />
          }
        </Tabs>
        {props.openPresupuesto ?
          <TabPanel
            value={selectedTab}
            index={AUTORIZACIONES_MENU_HISTORIAL.PRESUPUESTO}
          >
            <TablaHistorial datos={cambiosEnPresupuestos} />
          </TabPanel>
          :
          <TabPanel
            value={selectedTab}
            index={AUTORIZACIONES_MENU_HISTORIAL.SOLICITUD}
          >
            <TablaHistorial datos={cambiosEnSolicitudes} />
          </TabPanel>
        }
        <TabPanel
          value={selectedTab}
          index={AUTORIZACIONES_MENU_HISTORIAL.PRACTICA}
        >
          <TablaHistorial datos={cambiosEnPracticas} />
        </TabPanel>
        {!props.openIntegracion &&
          <>            
            <TabPanel
              value={selectedTab}
              index={AUTORIZACIONES_MENU_HISTORIAL.MATERIAL}
            >
              <TablaHistorial datos={cambiosEnMateriales} />
            </TabPanel>
            <TabPanel
              value={selectedTab}
              index={AUTORIZACIONES_MENU_HISTORIAL.PERIODO_PRACTICA}
            >
              <TablaHistorial datos={cambiosEnPeriodosPracticas} />
            </TabPanel>
          </>
        }
        {props.openIntegracion && (props.solicitud?.idTipoSolicitud ===
          TIPO_SOLICITUD_INTEGRACION.TERAPIA_INDIVIDUAL ||
          props.solicitud?.idTipoSolicitud ===
          TIPO_SOLICITUD_INTEGRACION.TERAPIA_MODULO) &&
          <TabPanel
            value={selectedTab}
            index={AUTORIZACIONES_INTEGRACION_MENU_HISTORIAL.TERAPIA}
          >
            <TablaHistorial datos={cambiosEnTerapia} />
          </TabPanel>
        }
        {props.openIntegracion && props.solicitud?.idTipoSolicitud ===
          TIPO_SOLICITUD_INTEGRACION.TRANSPORTE &&
          <TabPanel
            value={selectedTab}
            index={AUTORIZACIONES_INTEGRACION_MENU_HISTORIAL.TRANSPORTE}
          >
            <TablaHistorial datos={cambiosEnTransporte} />
          </TabPanel>
        }                          
      </DialogContent>
    </Dialog>
  );
};
